import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/common/wait_icon.png'
import _imports_1 from '@/assets/images/common/success_icon.png'
import _imports_2 from '@/assets/images/common/warn_icon.png'


const _hoisted_1 = {
  class: "message",
  style: {"width":"265rem"}
}
const _hoisted_2 = {
  key: 0,
  class: "icon"
}
const _hoisted_3 = {
  key: 0,
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1
}
const _hoisted_5 = {
  key: 2,
  src: _imports_2
}
const _hoisted_6 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { class: "animated animate__fadeInUp" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        ($props.type)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              ($props.type == 'warn')
                ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                : _createCommentVNode("", true),
              ($props.type == 'success')
                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                : _createCommentVNode("", true),
              ($props.type == 'error')
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_6, _toDisplayString($props.text), 1)
      ], 512), [
        [_vShow, $setup.visible]
      ])
    ]),
    _: 1
  }))
}